import FuturesEvidencePanel from './FuturesEvidencePanel'

export default function SpreadsOrdersListView() {
  return (
    <FuturesEvidencePanel
      title="Spreads Orders"
      accessLabel="Spreads"
      accessTarget="frmFuturesMainSubFormSpreads -> frmFuturesQrySpreads"
      description="Spread order control list. This tab owns spread orders and the generated futures legs that should not be edited from the Futures Orders tab."
      actions={['New', 'Edit', 'Delete', 'Mass Upload']}
      evidence={[
        'form_frmFuturesMainSubFormSpreads.txt',
        'form_frmFuturesQrySpreads.txt',
        'form_frmFuturesQrySpreadsAdd.txt',
        'form_frmFuturesQrySpreadsOrderAddMany.txt',
        'query_FuturesQrySpreads.txt',
      ]}
      notes={[
        'New suggests order_number with Suggest_IndexName("orders_spreads") and defaults date to Now().',
        'Edit reads the related -L1 futures leg flag from public_orders_futures.',
        'Delete soft-deletes public_orders_spreads and related public_orders_futures legs matching -L1/-L2.',
      ]}
    />
  )
}
